<template>
  <!--
    配置分组的统一外壳：替代原先重复的内联样式标题 div。
    toggleable 为 true 时，标题右侧显示总开关；关闭时折叠该组的具体设置，
    让“先启用、再配置”的层级更清晰。
  -->
  <div class="cfg-section" :class="{ 'is-off': toggleable && !on }">
    <div class="cfg-section__head">
      <span class="cfg-section__title">{{ title }}</span>
      <setting-switch
        v-if="toggleable"
        class="cfg-section__toggle"
        :value="value"
        :disabled="disabled"
        @input="$emit('input', $event)"
        @change="$emit('change', $event)"
      ></setting-switch>
    </div>
    <p v-if="help" class="cfg-help">{{ help }}</p>
    <!-- 有总开关时，关闭状态下隐藏子设置；无总开关时始终显示 -->
    <div v-if="!toggleable || on" class="cfg-section__body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import SettingSwitch from "./SettingSwitch";

  export default {
    name: "SettingSection",
    components: { SettingSwitch },
    props: {
      title: { type: String, required: true },
      help: { type: String, default: "" },
      // 是否显示总开关
      toggleable: { type: Boolean, default: false },
      value: { type: [Number, String, Boolean], default: 0 },
      disabled: { type: Boolean, default: false }
    },
    computed: {
      on() {
        return this.value === 1 || this.value === "1" || this.value === true;
      }
    }
  };
</script>

<style scoped lang="scss">
  .cfg-section {
    margin-top: 30px;
  }

  .cfg-section__head {
    display: flex;
    align-items: center;
    gap: 12px;
    min-height: 24px;
    padding-left: 10px;
    border-left: 5px solid var(--vtm-mint);
    margin-bottom: 5px;
  }

  .cfg-section__title {
    font-size: 15px;
    font-weight: 500;
    line-height: 24px;
    color: var(--vtm-ink);
  }

  .cfg-section__toggle {
    margin-left: auto;
  }

  // 关闭状态下标题条降低视觉权重
  .cfg-section.is-off .cfg-section__head {
    border-left-color: var(--vtm-line);
  }

  .cfg-section__body {
    margin-top: 8px;
  }
</style>
